// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-table {
  /* Border */
  --perxis-auto-table-border-top-width-inner: var(--perxis-auto-table-border-top-width, 1px);
  --perxis-auto-table-border-bottom-width-inner: var(--perxis-auto-table-border-bottom-width, 0);
  --perxis-auto-table-border-color-inner: var(--perxis-auto-table-border-color, var(--perxis-auto-root-ninth-color-inner));
  /* End Border */
}
.perxis-auto-1_16_13-table__item {
  padding-top: var(--perxis-auto-gap-vertical-purple-inner);
  padding-bottom: var(--perxis-auto-gap-vertical-purple-inner);
  border-top: var(--perxis-auto-table-border-top-width-inner) solid var(--perxis-auto-table-border-color-inner);
  border-bottom: var(--perxis-auto-table-border-bottom-width-inner) solid var(--perxis-auto-table-border-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
